import { Component, ViewChild } from '@angular/core';
import { EmployeeTypeModel } from './model/employee-type.model';
import { EmployeeTypeService } from './employee-type.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-employee-type',
  templateUrl: './employee-type.component.html',
  styleUrls: ['./employee-type.component.scss'],
  standalone: false
})
export class EmployeeTypeComponent {

  employeeTypeList: EmployeeTypeModel[] = [];
  isLoading = true;
  filter: FilterListItemModel[] = [
    { title: "Code", column: "code" },
    { title: "Name", column: "name" },
    { title: "Description", column: "description" },
    {
      title: "Is Active", column: "is_active", type: "boolean",
      values: [
        { title: "Yes", value: "1" },
        { title: "No", value: "0" },
      ]
    },
  ];
  displayedColumns = ['item', 'code', 'name', 'description', 'is_active', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: EmployeeTypeModel;
  dataSource = new MatTableDataSource(this.employeeTypeList);
  permission: any;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private employeeTypeService: EmployeeTypeService,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    public permissionService: PermissionService,
    private router: Router,
    private stateManagerService: StateManagerService
  ) {
    this.permission = permissionService.getPagePermission("employee-type");
  }

  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      this.isHandset = state.matches;
    });
  }

  ngAfterViewInit(): void {
    this.loadPreviousState();
  }

  loadPreviousState(): void {
    var previousState = this.stateManagerService.getState(this.constructor.name);
    if (previousState !== undefined && this.searchFilter != undefined) {
      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }
      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }
      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);
    } else {
      this.setSortColumn('name', 'asc');
      this.loadData();
    }
  }

  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    if (this.sort) {
      this.sort.sort({ id: column, start: direction, disableClear: false });
    }
  }

  setDataSource(list: EmployeeTypeModel[]) {
    this.dataSource = new MatTableDataSource(list);
    this.dataSource.sort = this.sort;
  }

  buildRequestData(): RequestData {
    let searchParam = this.searchColumFilter;
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: searchParam.advSearch || [],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.columnSortData,
      }
    };
    return requestData;
  }

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();
  }

  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.employeeTypeService.getEmployeeTypeList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        this.employeeTypeList = response.data.employee_types;
        this.setDataSource(this.employeeTypeList);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length > 0) {
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        this.snackBarService.openSnackBar({
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        });
      }
      this.isLoading = false;
    });
  }

  onRowSelected(info: EmployeeTypeModel): void {
    this.selectedItem = info;
  }

  sortData($event: any): void {
    if (this.sort) {
      this.columnSortData = [{ column: this.sort.active, order: this.sort.direction }];
      this.loadData();
    }
  }

  onEdit(info: EmployeeTypeModel): void {
    this.router.navigate(['system/employee-type-edit', info.id]);
  }

  onePageEvent(event: any): void {
    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;
    this.loadData();
  }
}
